import { uiStore } from 'shared/store/uiStore'
import { EnumAccessPageKeys } from 'entities/ExportRouters/lib/checkAccessPage'
import { AccessLayout } from 'entities/ExportRouters'
import { NumbersPath } from 'pages/settings/pages/numbers/route/numbersPath'

export const AddNumberAccessLayout = () => {
  return (
    <AccessLayout
      name={EnumAccessPageKeys.numbers_settings_add}
      onAccessDenied={() => {
        uiStore.changeRouteViaVue({
          path: `${NumbersPath.root}`,
        })
      }}
    />
  )
}
